const getRemScale = () => {
  const fontSize = +(document.documentElement?.style?.fontSize || '').replace('px', '');
  // console.log('scale', 750 / 10 / fontSize);
  return 750 / 10 / fontSize;
};

export default getRemScale;
